import { createSlice } from '@reduxjs/toolkit';

const initialStateValue = {
    modalDisplay: false,
    filters: [],
    searchList: [],
    // recentSearched: [],
}

const searchSlice = createSlice({
    name: 'search',
    initialState: initialStateValue,
    reducers: {
        openModal: (state, _) => {
            state.modalDisplay = true;
        },
        closeModal: (state, _) => {
            state.modalDisplay = false;
            state.filters = [];
            state.searchList = [];
        },
        addFilter: (state, action) => {
            state.filters.push(action.payload);
        },
        removeFilter: (state, action) => {
            state.filters = state.filters.filter(item => item !== action.payload);
        },
        clearFilters: (state, _) => {
            state.filters = [];
        },
        updateSearchList: (state, action) => {
            state.searchList = action.payload;
        },
        clearList: (state, _) => {
            state.searchList = [];
        }
    },
});

export const {
    openModal,
    closeModal,
    addFilter,
    removeFilter,
    clearFilters,
    updateSearchList,
    clearList,
} = searchSlice.actions;

export default searchSlice.reducer;
